<template>
  <AppDialog
    class="integration-wizard-link-projects-dialog"
    :show="show"
    :title="dialogTitle"
    append-to-body
    @close="close"
  >
    <div class="integration-wizard-link-projects-container">
      <div class="integration-wizard-link-projects-container-header">
        <div class="d-flex flex-column select-link-project">
          <div class="d-flex align-items-center text-light flex-row">
            <img
              :src="INTEGRATION_LOGO_URLS[integrationType]"
              class="mr-10"
              width="15"
              height="15"
              alt="Integration logo"
            />
            <strong> {{ integrationDisplayName }} {{ projectLabel }} </strong>
          </div>
        </div>
        <div class="d-flex flex-column link-icon-column"></div>
        <div class="d-flex flex-column select-link-project">
          <div class="d-flex align-items-center text-light flex-row">
            <img
              :src="HUBSTAFF_LOGO"
              class="mr-10"
              width="15"
              height="15"
              alt="Hubstaff logo"
            />
            <strong> Hubstaff project </strong>
          </div>
        </div>
        <div class="d-flex flex-column remove-item-column"></div>
      </div>
      <IntegrationWizardLinkItem
        v-for="project in currentProjects"
        ref="linkItems"
        :key="project.remote_id"
        :local-projects="localProjects"
        :remote-projects="projectOptions(project)"
        :selected="project"
        :is-removable="linkIsRemovable(project)"
        @check="onCheck"
        @remove="onItemRemove"
      />
      <div v-show="showNewLinkButton">
        <div
          class="btn-integration-wizard-link-dialog-new-item d-flex align-items-start justify-content-start flex-row"
          @click="addNewLinkItem"
        >
          <i class="hi hi-plus"></i>
          <div class="text">Add another</div>
        </div>
      </div>
      <p class="mt-30">
        It will take about 5 minutes to display synced {{ $filters.pluralize(2, taskLabel) }} from {{ integrationDisplayName }}.
      </p>
    </div>
    <template #footer>
      <AppButton @click="close">Cancel</AppButton>
      <AppButton
        type="primary"
        @click="save"
      >
        Save
      </AppButton>
    </template>
  </AppDialog>
</template>

<script>
import { differenceBy } from 'lodash-es';
import { INTEGRATION_LOGO_URLS, HUBSTAFF_LOGO } from '~/rails_assets';
import { createPersist } from '../../utils/persist';

const localStore = createPersist('integration-wizard');

export default {
  name: 'IntegrationWizardLinkProjectsDialog',
  props: {
    show: Boolean,
    allProjects: Array,
    localProjects: Array,
    currentProjects: Array,
    editMultiple: Boolean,
  },
  data() {
    const store = localStore.get('integrationWizardState');

    if (store.selectedProjects === undefined) {
      this.initializeSelectedProjects(store);
    }

    return {
      HUBSTAFF_LOGO,
      INTEGRATION_LOGO_URLS,
      integrationDisplayName: store.integration_display_name,
      integrationType: store.integration_type,
      projectLabel: store.labels.project,
      taskLabel: store.labels.task,
      showNewLinkButton: false,
    };
  },
  computed: {
    dialogTitle() {
      return `Connect ${this.integrationDisplayName} ${this.projectLabel}s with Hubstaff projects`;
    },
    projectOptions() {
      return (project) => {
        let options = [];

        if (project) {
          options.push(project);
        }
        if (this.editMultiple) {
          const diffProjects = differenceBy(this.allProjects, this.currentProjects, 'remote_id');

          if (diffProjects.length > 0) {
            options = options.concat(diffProjects);
          }

          return options;
        }

        return this.currentProjects;
      };
    },
    allLinked() {
      return this.allProjects.length === this.currentProjects.length;
    },
  },
  watch: {
    show(newShow) {
      if (newShow === true) {
        this.onCheck();
      }
    },
  },
  methods: {
    linkIsRemovable(project) {
      if (!this.editMultiple && this.currentProjects.length === 1) {
        return false;
      }

      return project.remote_id !== null || project.local_id !== null;
    },
    onCheck(localId, remoteId) {
      if (this.editMultiple) {
        if (this.$refs.linkItems !== undefined) {
          const store = localStore.get('integrationWizardState');

          if (localId) {
            store.selectedProjects.local.push(localId);
          }
          if (remoteId) {
            store.selectedProjects.remote.push(remoteId);
          }
          localStore.set('integrationWizardState', store);

          this.$refs.linkItems.forEach((component) => {
            component.$forceUpdate();
          });
        }
        if (this.allLinked) {
          return;
        }
        const existingNewEntry = this.currentProjects.find((p) => {
          return p.local_id == null && p.remote_id == null;
        });

        if (!existingNewEntry) {
          this.showNewLinkButton = true;
        }
      }
    },
    onItemRemove(removed) {
      const index = this.currentProjects.indexOf(removed);

      if (index !== -1) {
        this.spliceFromStore(removed, 'local');
        this.spliceFromStore(removed, 'remote');

        // eslint-disable-next-line vue/no-mutating-props
        this.currentProjects.splice(index, 1);
        this.onCheck();
      }
    },
    save() {
      this.$emit('save', this.currentProjects);
    },
    close() {
      const store = localStore.get('integrationWizardState');

      this.initializeSelectedProjects(store);
      this.$emit('close');
    },
    addNewLinkItem() {
      this.showNewLinkButton = false;
      this.$emit('add-new-link');
    },
    initializeSelectedProjects(store) {
      store.selectedProjects = { local: [], remote: [] };
      localStore.set('integrationWizardState', store);
    },
    spliceFromStore(removed, source) {
      const store = localStore.get('integrationWizardState');
      const value = removed[source + '_id'];

      if (value && value.toString() !== '-1') {
        const index = store.selectedProjects.local.indexOf(value.toString());

        store.selectedProjects[source].splice(index, 1);
        localStore.set('integrationWizardState', store);
      }
    },
  },
};
</script>
